<template>
  <v-overlay :color="'#fff'" :value="loading" z-index="10" opacity="1">
    <div class="overlay-content">
      <span class="loader-text">
        {{ $t("settings.airbyte_login_google_progress") }}
      </span>
      <v-progress-linear
        :value="progress"
        color="primary"
        background-color="element-bg-300"
        height="6"
        rounded></v-progress-linear>
    </div>
  </v-overlay>
</template>

<script>
  import definedAbility from "@/ability";

  export default {
    data() {
      return {
        ability: definedAbility(),
        loading: false,
        progress: 0,
      };
    },
    beforeMount() {
      this.displayLoader();
    },
    async mounted() {
      await this.handleAuth();
    },
    methods: {
      async handleAuth() {
        if (this.ability.can("view", "login to airbyte") && (this.$route.query?.code || this.$route.query?.error)) {
          if (this.$route.query.error) {
            await this.$router.replace({ name: "settings" });
            this.$admin.toast.error(this.$t("settings.airbyte_login_google_error"));

            return;
          }
          try {
            await this.$admin.dataProvider.customHttpCall("POST", "airbyte_sources/google/confirm", {
              code: this.$route.query.code,
            });

            await this.$router.replace({ name: "settings" });
            this.$admin.toast.success(this.$t("settings.airbyte_login_google_success"));
          } catch (e) {
            await this.$router.replace({ name: "settings" });
            this.$admin.toast.error(e.description || this.$t("generic.error"));
          }
        } else {
          this.$router.replace({ name: "settings" });
        }
      },

      displayLoader() {
        this.loading = true;
        /**
         * Simulated, non-linear loading. Loads as long as possible, slowing down the further it gets.
         */
        this.interval = setInterval(() => {
          const increment = (100 - this.progress) / 10;
          if (this.progress < 95) {
            this.progress += increment;
          } else {
            this.progress += 0.05;
          }
          if (this.progress > 99.5) {
            this.progress = 99.5;
          }
        }, 250);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .overlay-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;

    .loader-text {
      color: get-color("subtitle");
      @include text-body-2();
      margin-bottom: 16px;
    }
  }
</style>
